
import { InputHTMLAttributes } from 'react';
import classes from './Toggle.module.css';

export const Toggle = ({className, ...props}: InputHTMLAttributes<HTMLInputElement>) => {
    return <input {...props} type="checkbox" className={`${classes.toggle} ${className}`} />
}